import React, { useState, useEffect, useReducer } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function RemoveMembers(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])
    const [dataSources, setDataSources] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [selectedDimension, setSelectedDimension] = useState('')
    const [dimensionMembers, setDimensionMembers] = useState([])
    const [dimensionMembersDisplay, setDimensionMembersDisplay] = useState([])
    const [loadedMembers, setLoadedMembers] = useState([])
    const [membersToRemove, setMembersToRemove] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [removeFromSegmentation, setRemoveFromSegmentation] = useState(false)
    const [removeFromMasking, setRemoveFromMasking] = useState(false)
    const [removeFromFacts, setRemoveFromFacts] = useState(false)
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setIsLoadingRequest(true)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
                setDimensions([])
                setLoadedMembers([])
                
                let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
                getDimensions.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)
                    setDimensions(json)
                    setMembersToRemove(props.taskData.membersToRemove)
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setDimensions([])
                    setSelectedDimension('')
                    setDimensionMembers([])
                    setLoadedMembers([])
                    setIsLoadingRequest(false)
                })
            }).catch((ex) => {
                console.error(ex)
                setDataSourceSystemName('')
                setDataSources([])
                setDatabaseName('')
                setDimensions([])
                setSelectedDimension('')
                setDimensionMembers([])
                setIsLoadingRequest(false)
                setSearchTerm('')
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setDimensionMembers([])
            setLoadedMembers([])
        }
    }, [])

    useEffect(() => {
        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setIsLoadingRequest(true)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
                setDimensions([])
                setLoadedMembers([])
                setDimensionMembersDisplay([])
                
                let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
                getDimensions.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)
                    setDimensions(json)
                    setMembersToRemove(props.taskData.membersToRemove)
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setDimensions([])
                    setSelectedDimension('')
                    setDimensionMembers([])
                    setLoadedMembers([])
                    setIsLoadingRequest(false)
                })
            }).catch((ex) => {
                console.error(ex)
                setDataSourceSystemName('')
                setDataSources([])
                setDatabaseName('')
                setDimensions([])
                setSelectedDimension('')
                setDimensionMembers([])
                setIsLoadingRequest(false)
                setSearchTerm('')
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setDimensionMembers([])
            setLoadedMembers([])
        }
    }, [props.taskData.databaseId, props.taskData.databaseName, props.taskData.dataSourceSystemName, props.taskData.membersToRemove])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDataSourceSystemName('')
        setIsLoadingRequest(true)
        setDataSources([])
        setDimensions([])
        setDatabaseName('')
        setSelectedDimension('')
        setDimensionMembers([])
        setLoadedMembers([])
        setSearchTerm('')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dbName = ''
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    dbName = db.dBname
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(event.target.value, dbName, "", [], removeFromSegmentation, removeFromMasking, removeFromFacts)
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setIsLoadingRequest(false)
            setSelectedDimension('')
            setDimensionMembers([])
        })
    }

    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)
        setDimensions([])
        setLoadedMembers([])
        setIsLoadingRequest(true)

        let getDimensions = props.getDimensions(databaseId, event.target.value)
        getDimensions.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            setDimensions(json)

            dataSources.forEach((ds) => {
                if (ds.key === event.target.value) {
                    fireOnSaveEvent(databaseId, databaseName, event.target.value, membersToRemove, removeFromSegmentation, removeFromMasking, removeFromFacts)
                }
            })
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setDimensionMembers([])
            setLoadedMembers([])
            setIsLoadingRequest(false)
        })
    }

    function handleDimensionChange(event) {
        event.preventDefault()
        setSelectedDimension(event.target.value)
        setDimensionMembers([])
        setSearchTerm('')
        setIsLoadingRequest(true)
        callDimensionMembersFromDropDown(event.target.value)
    }

    function callDimensionMembersFromDropDown(dimensionSystemName) {
        if (dimensionSystemName !== 'Measures') {
            let getDimensionMembersCall = props.getDimensionMembers(databaseId, dataSourceSystemName, dimensionSystemName, [], '')
            getDimensionMembersCall.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                setDimensionMembers(json)
    
                let filtered = filterOutMembersBySearchTerm('', json)
                filtered.unshift({"alias": "[Remove All Members]","systemName": "-1","attributes": {},"children": []})
                setDimensionMembersDisplay(filtered)
    
                // Add already loaded to the state
                let copiedAlreadyLoaded = loadedMembers
                for (let x = 0; x < json.length; x++) {
                    copiedAlreadyLoaded.push(json[x]["systemName"])
                }
                setLoadedMembers(copiedAlreadyLoaded)
                fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, membersToRemove, removeFromSegmentation, removeFromMasking, removeFromFacts)
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setDimensions([])
                setSelectedDimension('')
                setDimensionMembers([])
                setLoadedMembers([])
                setIsLoadingRequest(false)
            })
        } else {
            setIsLoadingRequest(false)

            for (let x = 0; x < dimensions.length; x++) {
                if (dimensions[x]["typeOfDimension"] === -1) {
                    setDimensionMembers(dimensions[x]["members"])

                    let filtered = filterOutMembersBySearchTerm('', dimensions[x]["members"])
                    filtered.unshift({"alias": "[Remove All Measures]","systemName": "-1","attributes": {},"children": []})
                    setDimensionMembersDisplay(filtered)
                }
            }
        }
    }

    function callDimensionMembersFromButton() {
        if (selectedDimension !== 'Measures') {
            setIsLoadingRequest(true)
        
            let getDimensionMembersCall = props.getDimensionMembers(databaseId, dataSourceSystemName, selectedDimension, loadedMembers, searchTerm)
            getDimensionMembersCall.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                
                let copiedMembers = dimensionMembers
                setDimensionMembers(copiedMembers.concat(json))
    
                let filtered = filterOutMembersBySearchTerm(searchTerm, copiedMembers)
                setDimensionMembersDisplay(filtered)
                
                // Add already loaded to the state
                let copiedAlreadyLoaded = loadedMembers
                for (let x = 0; x < json.length; x++) {
                    copiedAlreadyLoaded.push(json[x]["systemName"])
                }
                setLoadedMembers(copiedAlreadyLoaded)
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setDimensions([])
                setSelectedDimension('')
                setDimensionMembers([])
                setLoadedMembers([])
                setIsLoadingRequest(false)
            })
        } else {
            setIsLoadingRequest(false)

            for (let x = 0; x < dimensions.length; x++) {
                if (dimensions[x]["typeOfDimension"] === -1) {
                    setDimensionMembers(dimensions[x]["members"])

                    let filtered = filterOutMembersBySearchTerm('', dimensions[x]["members"])
                    filtered.unshift({"alias": "[Remove All Measures]","systemName": "-1","attributes": {},"children": []})
                    setDimensionMembersDisplay(filtered)
                }
            }
        }
    }

    function filterOutMembersBySearchTerm(searchTerm, allMembers) {
        if (searchTerm.trim().length === 0) {
            return allMembers
        } else {
            let rtnVal = []
            for (let x = 0; x < allMembers.length; x++) {
                if (allMembers[x]["alias"].toLowerCase().indexOf(searchTerm.toLowerCase().trim()) > -1) {
                    rtnVal.push(allMembers[x])
                }
            }
            return rtnVal
        }
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {Array} toRemove - All member information we have marked for removal
     * @param {string} dimSystemName - Selected dimension system name
     * @param {string} zipFileName - Selected zip file for the current job
     * @param {string} fileWithinZip - Desktop database within zip file
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, toRemove, segmentation, masking, facts) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["membersToRemove"] = toRemove
            copied["removeFromSegmentation"] = segmentation
            copied["removeFromMasking"] = masking
            copied["removeFromFacts"] = facts
            props.onSave(copied)
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Remove Members From Data Source</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
                <Select
                    labelId="select-data-source-label"
                    id="select-data-source"
                    label="Select Data Source"
                    onChange={handleDataSourceChange}
                    value={dataSourceSystemName}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Data Source</MenuItem>
                        { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-dimension-label">Select Dimension</InputLabel>
                <Select
                    labelId="select-dimension-label"
                    id="select-dimension"
                    label="Select Dimension"
                    onChange={handleDimensionChange}
                    value={selectedDimension}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Dimension</MenuItem>
                        { dimensions.map((x) => x && <MenuItem key={x.systemName} value={x.systemName}>{x.alias}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="Search For Dimension Member"
                    variant="outlined"
                    value={searchTerm}
                    disabled={false}
                    onChange={(e) =>
                {
                e.preventDefault()
                setSearchTerm(e.target.value)
                let filtered = filterOutMembersBySearchTerm(e.target.value, dimensionMembers)
                setDimensionMembersDisplay(filtered)
                }} />
            </FormControl>
            <FormControl className="field" fullWidth>
                <FormControlLabel
                    control={(
                        <Checkbox
                            onChange={(event) => {
                                event.preventDefault()
                                setRemoveFromFacts(event.target.checked)
                                fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, membersToRemove, removeFromSegmentation, removeFromMasking, event.target.checked)
                            }}
                            name="facts"
                            checked={removeFromFacts} />
                        )}
                        label="Remove Member From Facts" />
            </FormControl>
            <FormControl className="field" fullWidth>
                <FormControlLabel
                    control={(
                        <Checkbox
                            onChange={(event) => {
                                event.preventDefault()
                                setRemoveFromSegmentation(event.target.checked)
                                fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, membersToRemove, event.target.checked, removeFromMasking, removeFromFacts)
                            }}
                            name="segmentation"
                            checked={removeFromSegmentation} />
                        )}
                        label="Remove Member From Segment" />
            </FormControl>
            <FormControl className="field" fullWidth>
                <FormControlLabel
                    control={(
                        <Checkbox
                            onChange={(event) => {
                                event.preventDefault()
                                setRemoveFromMasking(event.target.checked)
                                fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, membersToRemove, removeFromSegmentation, event.target.checked, removeFromFacts)
                            }}
                            name="segmentation"
                            checked={removeFromMasking} />
                        )}
                        label="Remove Member From Masking" />
            </FormControl>
            <FormControl className="field" fullWidth>
                <h4>Dimension Members</h4>
                <Box sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: '200px', overflowY: 'scroll', marginTop: '15px' }}>
                    <FormGroup>
                        {
                            dimensionMembersDisplay.map((member, memberIndex) => 
                                <FormControlLabel
                                    key={`dimension-member-${memberIndex}`}
                                    control={
                                        <Checkbox
                                            checked={membersToRemove && membersToRemove.filter(x => x.dimensionSystemName === selectedDimension && x.memberId === member.systemName && x.remove).length > 0}
                                            onChange={(e) => {
                                                e.preventDefault()
                                                let lookup = false
                                                let copied = membersToRemove

                                                if (copied) {
                                                    for (let x = 0; x < copied.length; x++) {
                                                        if (copied[x]["dimensionSystemName"] === selectedDimension && copied[x]["memberId"] === member.systemName) {
                                                            lookup = true
                                                            copied[x]["remove"] = e.target.checked
                                                        }
                                                    }
                                                } else {
                                                    copied = []
                                                }
                                                
                                                // Add entry if we didn't save it beforehand
                                                if (!lookup) {
                                                    copied.push({ "dimensionSystemName": selectedDimension, "memberId": member.systemName, "remove": e.target.checked })
                                                }
                        
                                                fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, copied, removeFromSegmentation, removeFromMasking, removeFromFacts)
                                                setMembersToRemove(copied)
                                                forceUpdate()
                                            }} />
                                    }
                                    label={member.alias}>
                                </FormControlLabel>)
                            }
                        <Button variant="contained" disabled={isLoadingRequest || dataSourceSystemName.trim().length === 0 || selectedDimension.trim().length === 0} onClick={callDimensionMembersFromButton}>Load More Members</Button>
                    </FormGroup>
                </Box>
            </FormControl>
        </Paper>
    )
}

export default RemoveMembers